
import React, { useState, useRef, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "./responsive-tabs-assessment.scss";
// import { IconMenuVertical } from "Icons";
import styled from "styled-components";
// import TabTails from "./TabTails";

const StyledTabsCommon = styled.div`
  .react-tabs {
    .react-tabs_tab--selected{
      color: ${({ theme }) => theme.color2};
      border-color: ${({ theme }) => theme.color2};
      border-bottom-color: ${({ theme }) => theme.color2};
    }
    .react-tabs__tab-list{
    display:flex;
    }

    .RRT__showmore--selected {
      border-bottom-color: ${({ theme }) => theme.primary};
    }
    .RRT__showmore-list {
      .RRT__tab--selected {
        border-left-color: ${({ theme }) => theme.primary};
      }
    }
  }
`;

const ResponsiveTabsAssessment = (props) => {
  const scrollContainer = useRef(null);

  useEffect(() => {
    if (scrollContainer.current) {
      scrollContainer.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollContainer.current.scrollLeft += evt.deltaY;
      });
    }
  }, [scrollContainer]);

  const renderTabs = () => {
    if (props.fromStudentAssessment || props.fromtestPreview) {
      return (
        <StyledTabsCommon style={{paddingBottom:"12px"}}>
        <Tabs forceRenderTabPanel={true}>
        <TabList>
          {props.items.map((item) => {
            return <Tab disabled={item.disabled}>{item.label}</Tab>;
          })}
        </TabList>

        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}
      </Tabs>
        </StyledTabsCommon>
      );
    } 
  };

  return renderTabs();
}

export default ResponsiveTabsAssessment;